import { Pipe, PipeTransform } from '@angular/core';
import { TranslateConfigService } from '@app/core/translate-config.service';

@Pipe({
  name: 'BoldTextPipe'
})
export class BoldTextPipe implements PipeTransform {

  constructor(private translateService: TranslateConfigService){}
  
    transform(labelKey: string, bold = false): string {
      if (!labelKey) return '';
  
      const translated = this.translateService.instant(labelKey);
      return bold ? `<strong>${translated}</strong>` : translated;
    }

}
